const $ = jQuery.noConflict();

const playVideo = () => {
	// Cache DOM
	const hero = $('.hero');
	const heroVideo = hero.find('video');
	const twb = $('.twb');
	const twbVideo = twb.find('video');

	// Bind Events
	if (heroVideo.length) {
		hero.on('click', () => {
			heroVideo[0].play();
		});
	}

	if (twbVideo.length) {
		twb.on('click', () => {
			twbVideo[0].play();
		});
	}
};

export default playVideo;
